import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "../../components/ui/card";
import { Label } from "../../components/ui/label";
import { Switch } from "../../components/ui/switch";

export function NotificationsTab({ settings, updateSetting }) {
  const items = [
    { key: "notifyAttendance", label: "Attendance Alerts", desc: "A student you're assigned to is expected but not yet marked present" },
    { key: "notifyCalendar", label: "Calendar & Meeting Reminders", desc: "Upcoming meetings and calendar events" },
    { key: "notifyCommFollowup", label: "Communication Follow-Ups", desc: "A logged communication is due for follow-up" },
    { key: "notifyCommTask", label: "Task Assignments", desc: "A task or reminder has been assigned to you" },
    { key: "notifyLicense", label: "License Expirations", desc: "A teaching or driver's license is expiring soon" },
  ];

  return (
    <div className="space-y-6">
      <Card>
        <CardHeader>
          <CardTitle>Bell Notifications</CardTitle>
          <CardDescription>Choose which alerts appear in your notification bell. These are your personal preferences.</CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {items.map((item) => (
              <div key={item.key} className="flex items-center justify-between p-4 border rounded-lg">
                <div className="space-y-1 pr-3">
                  <Label className="font-medium">{item.label}</Label>
                  <p className="text-sm text-muted-foreground">{item.desc}</p>
                </div>
                <Switch
                  checked={settings[item.key] !== false}
                  onCheckedChange={(checked) => updateSetting(item.key, checked)}
                  data-testid={`toggle-${item.key.replace(/([A-Z])/g, '-$1').toLowerCase()}`}
                />
              </div>
            ))}
          </div>
          <p className="text-sm text-muted-foreground bg-muted p-3 rounded-lg">
            Note: Attendance alerts also depend on your school administrator enabling attendance reminders (Settings &rsaquo; Notifications &amp; Email). Turning a category off here stops those notifications from reaching your bell.
          </p>
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle>Email Reminders</CardTitle>
          <CardDescription>Reminder emails sent to your inbox. These are your personal preferences.</CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="flex items-center justify-between p-4 border rounded-lg">
            <div className="space-y-1 pr-3">
              <Label className="font-medium">Daily Assessment Reminders</Label>
              <p className="text-sm text-muted-foreground">If you lead a class block and no assessments have been recorded for it by 2:00 PM, we'll email you a reminder.</p>
            </div>
            <Switch
              checked={settings.assessmentReminderEmail !== false}
              onCheckedChange={(checked) => updateSetting("assessmentReminderEmail", checked)}
              data-testid="toggle-assessment-reminder-email"
            />
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
